import {
  Box,
  Collapse,
  Stack,
  Typography,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Pagination,
  Dialog,
  PaginationItem,
  StepButton,
  Chip,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import EditNoteOutlinedIcon from "@mui/icons-material/EditNoteOutlined";
import PlaylistAddCheckOutlinedIcon from "@mui/icons-material/PlaylistAddCheckOutlined";
import NoteOutlinedIcon from "@mui/icons-material/NoteOutlined";
import BookmarkBorderRoundedIcon from "@mui/icons-material/BookmarkBorderRounded";
import { useAppDispatch, useAppSelecter } from "../../hooks/storeHooks";
import { RootState } from "../../store/store";
import UpdateSubtopicTopicDialog from "./UpdateSubtopicTopicDialog";
import { motion, AnimatePresence, useAnimate } from "framer-motion";
import {
  fetchAllClusterQues,
  getQuestionComments,
  mappingUpdate,
} from "../../store/slices/QuestionReview/QuestionReviewSlice";
import FormComp from "./SingleQuestionAdd/FormComp";
import ClusterCard from "./ClusterCard";
import CustomContainedButton from "../../Components/CustomContainedButton";
import UpdatedQuestionPreviewWrapper from "../contentFeedback/UpdatedQuestionPreviewWrapper";
import { ObjectValues } from "../login";
import CustomIconButton from "../../Components/CustomIconButton";
import CommentsSection from "./CommentsSection";
import { set, sum } from "lodash";
import ConfirmationDialog from "../../Components/ConfirmationDialog";
import {
  ColorlibConnector,
  CssStepperHorizontal,
} from "../contentFeedback/EditScreen";
import { showSnack } from "../../store/slices/constants";
import {
  fetchAllClusters,
  fetchAllSubtopics,
} from "../../store/slices/contentFeedback/contentFeedbackSlice";
import { ArrowBack, ArrowRight } from "@mui/icons-material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { colors } from "./SubtopicCard";
import { singleLineEllipsis } from "../../Components/AllCards/layouts/CardHeader";
export interface Step {
  label: string;
  description: any;
  completed: boolean;
  content: (que: any) => React.ReactNode;
}

function SingleClusterCard({
  setFilters,
  filters,
  setLoading,
  loadingScreen,
  localFilterState,
}: any) {
  const [open, setOpen] = useState<string | null>(filters.subtopic_id ?? null);

  const [changeSubTopic, setChangeSubTopic] = useState(false);
  const [reviewComplete, setReviewComplete] = useState<any>(false);
  const [isQuestionEdit, setisQuestionEdit] = useState(false);
  const [newPath, setNewPath] = useState<any>(false);
  const [selectedStatus, setStatus] = useState<string>("pending");
  const { masters } = useAppSelecter(
    (state: RootState) => state.contentFeedback
  );
  const [currentQuestion, setQuestion] = useState<null | ObjectValues>(null);
  const [reviewLaterConfirm, setReviewLater] = useState<null | ObjectValues>(
    null
  );
  const [moveToPending, setPending] = useState<null | ObjectValues>(null);
  const dispatch = useAppDispatch();
  const [activeStep, setActiveStep] = useState<number>(0);
  useEffect(() => {
    if (filters.cluster_id) {
      setLoading(true);
      dispatch(
        fetchAllClusterQues(`${filters.cluster_id}/?status=${selectedStatus}`)
      )
        .unwrap()
        .then((res) => {
          handleChangePage(0, null, res);
        });
    }
  }, [dispatch, filters.cluster_id, selectedStatus]);
  // const refreashScrren = (que: any, change?: any) => {

  //     setLoading(true)

  //   dispatch(fetchAllSubtopics(filters.topic_id ? filters.topic_id : ""))
  //     .unwrap() // wait for success
  //     .then(() => {
  //       dispatch(
  //         fetchAllClusters(filters.subtopic_id ? filters.subtopic_id : "")
  //       )
  //         .unwrap() // wait for success
  //         .then(() => {
  //           dispatch(
  //             fetchAllClusterQues(
  //               `${filters.cluster_id}/?status=${selectedStatus}`
  //             )
  //           )
  //             .unwrap() // wait for success
  //             .then((res) => {
  //               handleChangePage(
  //                 change ? currentQuestion?.page + 1 : currentQuestion?.page,
  //                 selectedStatus === "pending" ? change : undefined,
  //                 res
  //               );

  //             });
  //         });
  //     });
  // };
  const refreashScrren = async (que: any, change?: any) => {
    try {
      setLoading(true);
      setNewPath(false);
      const promises = [
        dispatch(fetchAllSubtopics(filters.topic_id || "")).unwrap(),
        dispatch(fetchAllClusters(filters.subtopic_id || "")).unwrap(),
        dispatch(
          fetchAllClusterQues(`${filters.cluster_id}/?status=${selectedStatus}`)
        ).unwrap(),
      ];

      const [subtopicsRes, clustersRes, clusterQuesRes] = await Promise.all(
        promises
      );

      // Once ALL succeed
      //  change ? currentQuestion?.page + 1 :
      handleChangePage(
        currentQuestion?.page,
        selectedStatus === "pending" ? change : undefined,
        clusterQuesRes
      );
    } catch (err) {
      console.error("Failed while refreshing screen", err);
    } finally {
    }
  };
  useEffect(() => {
    if (filters.cluster_id && masters.clusters.length > 0) {
      setFilters((prev: any) => ({
        ...prev,
        cluster:
          masters.clusters.find((s) => s.id === filters.cluster_id) ??
          prev.cluster,
      }));
    }
  }, [masters.clusters]);
  const { questions, comments } = useAppSelecter(
    (state: RootState) => state.QuestionReview
  );
  const handleChangePage = async (page: number, change?: any, ques?: any) => {
    setNewPath(false);
    setActiveStep(0);
    if (ques && ques.length > 0 && ques[page]) {
      await setQuestion({ ...ques[page], page: page });
      await dispatch(getQuestionComments(ques[page].id))
        .unwrap()
        .then(() => {
          // setLoading(false)
        });
    } else if (masters.clusters && filters.cluster && change) {
      const list = masters.clusters.filter((s) =>
        localFilterState.cluster !== "all"
          ? localFilterState.cluster === "pending"
            ? s.pending + s.save_for_later !== 0
            : s.pending + s.reviewed + s.save_for_later !== 0
          : true
      );
      const index = list.findIndex((c: any) => c.id === filters.cluster.id);
      if (index !== -1) {
        const nextCluster = list[index + 1];
        if (nextCluster) {
          setFilters((prev: any) => ({
            ...prev,
            cluster: nextCluster,
            cluster_id: nextCluster.id,
            cluster_color: colors[(index + 1) % colors.length],
          }));
        }
      }
    } else {
      setQuestion(null);
      setLoading(false);
    }
  };
  useEffect(() => {
    setLoading(false);
  }, [currentQuestion]);
  const MotionBox = motion(Box);

  const steps: Step[] = [
    {
      label: activeStep < 1 ? "Approve Subtopic" : "Approved Subtopic",
      description:
        activeStep < 1 ? (
          `${filters.subtopic} / Move to another Subtopic`
        ) : newPath && newPath.subtopic ? (
          <Typography>
            New subtopic - {newPath.exam} • {newPath.goal} • {newPath.section} •{" "}
            {newPath.topic} •{" "}
            <Typography component="span" fontWeight="bold">
              {newPath.subtopic}
            </Typography>
          </Typography>
        ) : (
          "Completed"
        ),
      completed: true,
      content: (que: any) => (
        <MotionBox
          // initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.3 }}
          sx={{
            p: "16px 0 0",
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <CustomIconButton
            key={"choose another subtopic"}
            content={<NoteOutlinedIcon />}
            variant="outlined"
            icon={"choose another subtopic"}
            sx={{ minWidth: "fit-content", mr: "5px" }}
            onClick={() => {
              setChangeSubTopic(true);
            }}
          />

          <CustomContainedButton
            otherProps={{
              disabled: false,
              onClick: handleNext,
              sx: { minWidth: "60px" },
            }}
            icon="Next"
            content={<ArrowForwardIcon sx={{ height: "16px" }} />}
          />
        </MotionBox>
      ),
    },
    {
      label: activeStep < 2 ? "Approve Cluster" : "Approved Cluster",
      description:
        activeStep < 2 ? (
          `${filters.cluster.name} / Choose Another Cluster`
        ) : newPath &&
          (newPath.cluster.name ? newPath.cluster.name : newPath.cluster) ? (
          <Typography>
            New cluster -{" "}
            <Typography component="span" fontWeight="bold">
              {newPath.cluster.name ? newPath.cluster.name : newPath.cluster}
            </Typography>{" "}
            • {newPath.cluster.description} • {newPath.cluster.type}
          </Typography>
        ) : (
          "Completed"
        ),
      completed: true,
      content: (que: any) => (
        <MotionBox
          // initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.3 }}
          sx={{
            p: "16px 0 0",
            display: "flex",
            gap: "8px",
            justifyContent: "space-between",
            width: "100%",
            flexWrap: "wrap",
          }}
        >
          <CustomIconButton
            {...{
              disabled: false,
              onClick: handleBack,
              sx: { minWidth: "fit-content" },
              variant: "outlined",
            }}
            content="Back"
            icon={<ArrowBack sx={{ height: "16px" }} />}
          />
          <Box sx={{ display: "flex", gap: "10px" }}>
            <CustomIconButton
              key={"choose another cluster"}
              variant="outlined"
              content={<NoteOutlinedIcon />}
              icon={"choose another cluster"}
              sx={{ minWidth: "fit-content", mr: "5px" }}
              onClick={() => {
                setChangeSubTopic(true);
              }}
            />
            <CustomContainedButton
              otherProps={{
                disabled: false,
                onClick: handleNext,
                sx: { minWidth: "fit-content" },
              }}
              icon="Next"
              content={<ArrowForwardIcon sx={{ height: "16px" }} />}
            />
          </Box>
        </MotionBox>
      ),
    },
    {
      label: "Question Quality Check",
      description:
        "Review question quality and take appropriate action to ensure content excellence",
      completed: true,
      content: (que: any) => (
        <MotionBox
          // initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          transition={{ duration: 0.35 }}
          sx={{
            p: "16px 0 0",
            display: "flex",
            gap: "8px",
            justifyContent: "space-between",
            width: "100%",
            flexWrap: "wrap",
          }}
        >
          <CustomIconButton
            {...{
              disabled: false,
              onClick: handleBack,
              sx: { minWidth: "fit-content" },
              variant: "outlined",
            }}
            content="Back"
            icon={<ArrowBack sx={{ height: "16px" }} />}
          />
          <Box sx={{ display: "flex", gap: "10px" }}>
            {" "}
            <CustomIconButton
              variant="outlined"
              content={<EditNoteOutlinedIcon />}
              icon="Edit"
              sx={{ minWidth: "fit-content", mr: "5px" }}
              onClick={() => setisQuestionEdit(true)}
            />
            {newPath.cluster_id && (
              <CustomContainedButton
                otherProps={{
                  disabled: false,
                  onClick: () =>
                    setReviewComplete({ ...que, only_cluster: true }),
                  sx: { minWidth: "fit-content" },
                }}
                icon="Submit Cluster"
                content={<PlaylistAddCheckOutlinedIcon />}
              />
            )}
            <CustomContainedButton
              otherProps={{
                disabled: false,
                onClick: () => setReviewComplete(que),
                sx: { minWidth: "fit-content" },
              }}
              icon="Publish"
              content={<PlaylistAddCheckOutlinedIcon />}
            />
          </Box>
          {reviewComplete && (
            <ConfirmationDialog
              title="Confirmation"
              content={
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                  <Typography variant="body1">
                    Are you sure you want to{" "}
                    <strong>
                     {reviewComplete.only_cluster?"let this question be under review": "mark this question as correct without any changes"}{" "}
                    {newPath?.subtopic ? "and move to another path" : ""} ?
                    </strong>
                  </Typography>
                  {newPath && (
                    <Box
                      sx={{
                        mt: 2,
                        mb: 1,
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                      }}
                    >
                      {/* Previous hierarchy (source) */}
                      <Box
                        sx={{
                          flex: 1,
                          bgcolor: "#f5f5f5",
                          borderRadius: 2,
                          p: 2,
                          minWidth: 180,
                          border: "1px solid #e0e0e0",
                        }}
                      >
                        <Typography
                          variant="caption"
                          color="text.secondary"
                          fontWeight={500}
                        >
                          Current Path
                        </Typography>
                        <Typography sx={{ mt: 0.5 }}>
                          {filters.exam} • {filters.goal} • {filters.section} •{" "}
                          {filters.topic} •{" "}
                          <Typography
                            component="span"
                            fontWeight="bold"
                            display="inline"
                          >
                            {filters.subtopic}
                          </Typography>
                          {" • "}
                          <Typography
                            component="span"
                            fontWeight="bold"
                            display="inline"
                          >
                            {filters.cluster?.name}
                          </Typography>
                          {filters.cluster?.type ? (
                            <>
                              {" ("}
                              <Typography component="span" display="inline">
                                {filters.cluster.type}
                              </Typography>
                              {")"}
                            </>
                          ) : null}
                        </Typography>
                        {filters.cluster?.description && (
                          <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{ mt: 0.5 }}
                          >
                            {filters.cluster.description}
                          </Typography>
                        )}
                      </Box>

                      {/* Arrow */}
                      <Box
                        sx={{ display: "flex", alignItems: "center", px: 1 }}
                      >
                        <ArrowRight sx={{ fontSize: 32, color: "#1976d2" }} />
                      </Box>

                      {/* New hierarchy (destination) */}
                      <Box
                        sx={{
                          flex: 1,
                          bgcolor: "#e3f2fd",
                          borderRadius: 2,
                          p: 2,
                          minWidth: 180,
                          border: "1px solid #90caf9",
                        }}
                      >
                        <Typography
                          variant="caption"
                          color="primary"
                          fontWeight={500}
                        >
                          Destination Path
                        </Typography>
                        <Typography sx={{ mt: 0.5 }}>
                          {newPath.exam} • {newPath.goal} • {newPath.section} •{" "}
                          {newPath.topic} •{" "}
                          <Typography
                            component="span"
                            fontWeight="bold"
                            display="inline"
                          >
                            {newPath.subtopic}
                          </Typography>
                          {" • "}
                          <Typography
                            component="span"
                            fontWeight="bold"
                            display="inline"
                          >
                            {newPath.cluster?.name}
                          </Typography>
                          {newPath.cluster?.type ? (
                            <>
                              {" ("}
                              <Typography component="span" display="inline">
                                {newPath.cluster.type}
                              </Typography>
                              {")"}
                            </>
                          ) : null}
                        </Typography>
                        {newPath.cluster?.description && (
                          <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{ mt: 0.5 }}
                          >
                            {newPath.cluster.description}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                  )}
                  {reviewComplete.only_cluster ? (
                    <Typography variant="body2" sx={{ mt: 1 }}>
                     <em>Note:</em> Once submitted, this question will not {" "}
<strong>be published</strong> and will be available under the destination path for review again.
                    </Typography>
                  ) : (
                    <Typography variant="body2" sx={{ mt: 1 }}>
                      <em>Note:</em> Once submitted, this question will be{" "}
                      <strong> published </strong>
                      and immediately{" "}
                      <strong>
                        {" "}
                        visible in the NetPractice app
                        {newPath && newPath.subtopic
                          ? ` under destination Path.`
                          : "."}{" "}
                      </strong>
                      Please review carefully before proceeding.
                    </Typography>
                  )}
                </Box>
              }
              sx={{
                "& .MuiDialog-container": { backdropFilter: "blur(3px)" },
              }}
              customWidth="fit-content"
              yesButtonText={reviewComplete.only_cluster?"Yes, Move":
                newPath?.subtopic ? "Yes, Move and Publish" : "Yes, Publish"
              }
              noButtonText="No"
              open={Boolean(reviewComplete)}
              onClose={() => setReviewComplete(false)}
              onSubmit={async () => {
                if (reviewComplete?.id) {
                  handleApproveWithAnimation(que);
                  dispatch(
                    mappingUpdate({
                      id: reviewComplete.id,
                      body: newPath
                        ? reviewComplete.only_cluster
                          ? { cluster: newPath.cluster_id }
                          : { cluster: newPath.cluster_id, status: "reviewed" }
                        : { status: "reviewed" },
                    })
                  )
                    .unwrap()
                    .then(() => {
                      dispatch(
                        showSnack({
                          open: true,
                          message: "Question published.",
                          severity: "success",
                        })
                      );
                      setReviewComplete(false);
                      // setChange
                      refreashScrren(que, "change");
                    })
                    .catch(() => {
                      dispatch(
                        showSnack({
                          open: true,
                          message:
                            "Failed to publish question. Please try again.",
                          severity: "error",
                        })
                      );
                    });
                }
              }}
            />
          )}
          {/* Confirmation Dialog */}

          {/* Fullscreen Edit Dialog */}
          {isQuestionEdit && (
            <Dialog open fullScreen>
              <FormComp
                filters={filters}
                onClose={() => setisQuestionEdit(false)}
                reviewLater={setReviewLater}
                newPath={newPath}
                onSubmit={(que: any) => {
                  handleApproveWithAnimation(que);
                  setisQuestionEdit(false);
                  refreashScrren(que, "change");
                }}
                question={{
                  ...que,
                  languages_available:
                    que.translation
                      .map((s: { language: any }) => s.language)
                      .join(",") ?? "english",
                }}
              />
            </Dialog>
          )}
        </MotionBox>
      ),
    },
  ];
  const handleApproveWithAnimation = async (que: any, later?: any) => {
    const boxEl = document.getElementById(`${que.id}box-to-move`);
    const chipEl = trashRef.current;

    if (boxEl && chipEl) {
      const boxRect = boxEl.getBoundingClientRect();
      const chipRect = chipEl.getBoundingClientRect();

      // center-to-center translation
      const boxCenterX = boxRect.left + boxRect.width / 2;
      const boxCenterY = boxRect.top + boxRect.height / 2;
      const chipCenterX = chipRect.left + chipRect.width / 2;
      const chipCenterY = chipRect.top + chipRect.height / 2;

      const translateX = chipCenterX - boxCenterX;
      const translateY = chipCenterY - boxCenterY;

      await animate(
        boxEl,
        {
          x: translateX,
          y: translateY,
          scale: 0.2, // shrink into chip
          opacity: 0,
        },
        { duration: 0.6, ease: "easeInOut" }
      );
    }
  };
  const [scope, animate] = useAnimate();
  const trashRef = useRef<HTMLDivElement | null>(null);
  const handleNext = (): void => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };
  const handleBack = (): void => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  return filters.cluster?.name ? (
    <AnimatePresence>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Subtopic Header */}
        <ClusterCard
          setStatus={setStatus}
          trashRef={trashRef}
          filters={filters}
          selectedStatus={selectedStatus}
        />
        {/* <Divider /> */}
        {questions.length === 0 ? (
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {"No cluster selected."}
          </Box>
        ) : (
          <motion.div
            id={`${currentQuestion?.id ?? ""}box-to-move`}
            key={currentQuestion?.id ?? ""}
            initial={{ opacity: 1, scale: 1 }}
            style={{
              display: "flex",
              flexDirection: "row",
              flex: 8,
              overflow: "hidden",
            }}
          >
            <Stack
              sx={{
                display: "flex",
                flexDirection: "row",
                flex: 8,
                overflow: "hidden",
              }}
            >
              <Stack
                sx={{
                  flex: 8,
                  display: "flex",
                  flexDirection: "column",
                  width: "60%",
                  minWidth: "calc(100% - 410px)",
                }}
              >
                <Stack
                  sx={{
                    overflowY: "auto",
                    flex: 8,
                    boxSizing: "border-box",
                    width: "100%",
                    gap: "10px",
                  }}
                  className="scrollBluePrimarythin"
                >
                  {currentQuestion
                    ? [currentQuestion]
                        // .filter(
                        //   (s) => s.pending + s.reviewed + s.save_for_later !== 0
                        // )
                        .map((que: any) => {
                          const { id, reviewed, pending, v2_to_v3 } = que;
                          return (
                            <Box
                              // boxShadow="rgba(0, 0, 0, 0.2) 0px 3px 3px -2px, rgba(0, 0, 0, 0.14) 0px 3px 4px 0px, rgba(0, 0, 0, 0.12) 0px 1px 8px 0px"
                              sx={{
                                borderRadius: "8px",
                                color: "#4f4f4f",
                                // border: "2px solid grey",
                                // bgcolor: "white",
                                m: "0 0 8px",
                                height: "fit-content",
                                boxSizing: "border-box",
                                padding: "0 16px 11px 16px",
                                margin: "0 5px 0 0",
                                width: "calc(100% - 5px)",
                                flex: 8,
                              }}
                            >
                              <Stack
                                direction="row"
                                alignItems="center"
                                justifyContent="space-between"
                                sx={{
                                  borderRadius: "8px 8px 0 0",
                                  p: "4px 12px",
                                  // borderBottom: "1px solid #e5e7eb",
                                  // bgcolor: "#f9fafb",
                                  flex: 8,
                                }}
                              >
                                {/* Title */}
                                <Box sx={{ display: "flex", gap: "5px" }}>
                                  {" "}
                                  <Typography
                                    variant="h6"
                                    sx={{
                                      textDecoration: "underline",
                                      fontSize: "1rem",
                                      fontWeight: 600,
                                      color: "#111827",
                                    }}
                                  >
                                    Question
                                  </Typography>
                                  <Chip
                                    label={`id: #${id}`}
                                    size="small"
                                    sx={{
                                      border: "1px solid rgb(0 0 0 / 60%)",
                                      borderRadius: "4px",
                                      padding: "0",
                                      color: "rgb(0 0 0 / 60%)",
                                      fontSize: "0.75rem",
                                      background: "transparent",
                                      "& .MuiChip-label": {
                                        padding: "0 3px !important",
                                      },
                                      ...singleLineEllipsis,
                                    }}
                                  />
                                </Box>
                                <ConfirmationDialog
                                  title="Confirmation"
                                  content="Are you sure you want to move this question to pending again?"
                                  sx={{
                                    "& .MuiDialog-container": {
                                      backdropFilter: "blur(3px)",
                                    },
                                  }}
                                  customWidth="fit-content"
                                  yesButtonText="Yes, Move"
                                  noButtonText="No"
                                  open={Boolean(moveToPending)}
                                  onClose={() => setPending(null)}
                                  onSubmit={async () => {
                                    if (moveToPending?.id) {
                                      handleApproveWithAnimation(que);
                                      dispatch(
                                        mappingUpdate({
                                          id: moveToPending.id,
                                          body: { status: "pending" },
                                        })
                                      )
                                        .unwrap()
                                        .then(() => {
                                          setPending(null);
                                          dispatch(
                                            showSnack({
                                              open: true,
                                              message:
                                                "Question moved to pending.",
                                              severity: "success",
                                            })
                                          );
                                          refreashScrren(
                                            moveToPending,
                                            "pending"
                                          );
                                        })
                                        .catch(() => {
                                          dispatch(
                                            showSnack({
                                              open: true,
                                              message:
                                                "Failed to move question to pending. Please try again.",
                                              severity: "error",
                                            })
                                          );
                                        });
                                    }
                                  }}
                                />
                                {selectedStatus !== "reviewed" ? (
                                  currentQuestion?.v2_to_v3 ===
                                  "save_for_later" ? (
                                    <CustomIconButton
                                      variant="outlined"
                                      content={
                                        <>
                                          <BookmarkBorderRoundedIcon fontSize="small" />
                                          &nbsp;Remove Flag
                                        </>
                                      }
                                      sx={{
                                        minWidth: "fit-content",
                                        mr: "5px",
                                      }}
                                      onClick={() => setReviewLater(que)}
                                    />
                                  ) : (
                                    <CustomIconButton
                                      variant="outlined"
                                      content={
                                        <>
                                          <BookmarkBorderRoundedIcon fontSize="small" />
                                          &nbsp;Flag for Review
                                        </>
                                      }
                                      sx={{
                                        minWidth: "fit-content",
                                        mr: "5px",
                                      }}
                                      onClick={() => setReviewLater(que)}
                                    />
                                  )
                                ) : (
                                  ""
                                )}
                                {selectedStatus === "reviewed" && (
                                  <CustomIconButton
                                    variant="outlined"
                                    content={"Move to pending"}
                                    sx={{ minWidth: "fit-content", mr: "5px" }}
                                    onClick={() => setPending(que)}
                                  />
                                )}{" "}
                                {/* Stepper on the right */}
                                {/* <Box
                                sx={{
                                  width: "calc(100% - 140px)",
                                  maxWidth: "700px",
                                }}
                              >
                                <Stepper
                                  nonLinear
                                  activeStep={activeStep}
                                  connector={<ColorlibConnector />}
                                  sx={{
                                    "& .MiStepConnector-root": {
                                      "&.Mui-completed .MuiStepConnector-line":
                                        {
                                          border:
                                            "1px dashed #000000 !important",
                                        },
                                    },
                                  }}
                                >
                                  {steps.map((label, index) => (
                                    <Step
                                      key={label.label}
                                      disabled
                                      completed={activeStep > index}
                                      sx={{
                                        "& .MuiStepLabel-root": {
                                          "& .MuiStepLabel-iconContainer": {
                                            "& .MuiStepIcon-root.Mui-active": {
                                              color: "transparent",
                                              borderRadius: "50%",
                                              border: "2px solid #519C66",
                                              "& .MuiStepIcon-text": {
                                                fill: "#519C66",
                                              },
                                            },
                                          },
                                        },
                                      }}
                                    >
                                      <StepButton color="inherit"></StepButton>
                                    </Step>
                                  ))}
                                </Stepper>
                              </Box> */}
                              </Stack>

                              <Collapse
                                in={true}
                                timeout="auto"
                                unmountOnExit
                                className="scrollBluePrimarythin"
                                sx={{
                                  flex: 8,
                                  height: "calc(100% - 44px)",
                                  "& .MuiCollapse-wrapper": {
                                    minHeight: "100%",
                                  },
                                }}
                              >
                                <Box
                                  key={id}
                                  sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "10px",
                                    justifyContent: "space-between",
                                    flex: 8,
                                    height: "100%",
                                  }}
                                >
                                  {" "}
                                  {changeSubTopic && (
                                    <UpdateSubtopicTopicDialog
                                      changeSubTopic={changeSubTopic}
                                      setChangeSubTopic={setChangeSubTopic}
                                      {...{ setFilters, filters }}
                                      cluster
                                      onSubmit={(newFilters: any) => {
                                        if (
                                          newFilters.cluster_id !== undefined
                                        ) {
                                          setNewPath(newFilters);
                                          setChangeSubTopic(false);
                                          setActiveStep(2);
                                          // handleApproveWithAnimation(que);
                                          // dispatch(
                                          //   mappingUpdate({
                                          //     id: que.id,
                                          //     body: { cluster: cluster },
                                          //   })
                                          // )
                                          //   .unwrap() // wait for success
                                          //   .then(() => {
                                          //     setChangeSubTopic(false);
                                          //     refreashScrren(que, "change");
                                          //     dispatch(
                                          //       showSnack({
                                          //         open: true,
                                          //         message:
                                          //           "Question shifted to another cluster.",
                                          //         severity: "success",
                                          //       })
                                          //     );
                                          //   })
                                          //   .catch(() => {
                                          //     dispatch(
                                          //       showSnack({
                                          //         open: true,
                                          //         message:
                                          //           "Failed to shift question. Please try again.",
                                          //         severity: "error",
                                          //       })
                                          //     );
                                          //   });
                                        }
                                      }}
                                    />
                                  )}
                                  {Boolean(reviewLaterConfirm) && (
                                    <ConfirmationDialog
                                      title="Confirmation"
                                      content={
                                        reviewLaterConfirm?.v2_to_v3 ===
                                        "save_for_later"
                                          ? "Are you sure you want to remove this question from your Review Later list?"
                                          : "Are you sure you want to move this question to your Review Later list?"
                                      }
                                      sx={{
                                        "& .MuiDialog-container": {
                                          backdropFilter: "blur(3px)",
                                        },
                                      }}
                                      customWidth="fit-content"
                                      yesButtonText={
                                        reviewLaterConfirm?.v2_to_v3 ===
                                        "save_for_later"
                                          ? "Yes, Remove flag"
                                          : "Yes, Flag"
                                      }
                                      noButtonText="No"
                                      open={Boolean(reviewLaterConfirm)}
                                      onClose={() => setReviewLater(null)}
                                      onSubmit={async () => {
                                        if (reviewLaterConfirm?.id) {
                                          dispatch(
                                            mappingUpdate({
                                              id: reviewLaterConfirm.id,
                                              body: {
                                                status:
                                                  reviewLaterConfirm.v2_to_v3 ===
                                                  "save_for_later"
                                                    ? "pending"
                                                    : "save_for_later",
                                              },
                                            })
                                          )
                                            .unwrap()
                                            .then(() => {
                                              setReviewLater(null);
                                              dispatch(
                                                showSnack({
                                                  open: true,
                                                  message:
                                                    reviewLaterConfirm.v2_to_v3 ===
                                                    "save_for_later"
                                                      ? "Flag removed from this question."
                                                      : "Question has been flagged for review.",
                                                  severity: "success",
                                                })
                                              );
                                              refreashScrren(
                                                reviewLaterConfirm
                                              );
                                            })
                                            .catch(() => {
                                              dispatch(
                                                showSnack({
                                                  open: true,
                                                  message:
                                                    "Failed to update flag status. Please try again.",
                                                  severity: "error",
                                                })
                                              );
                                            });
                                        }
                                      }}
                                    />
                                  )}
                                  {selectedStatus === "reviewed" ? (
                                    <Stack>
                                      <Box
                                        sx={{
                                          p: 1.5,
                                          bgcolor: "#f5f5f5",
                                          borderRadius: 2,
                                          boxShadow: 1,
                                          display: "inline-block",
                                          mt: "15px",
                                        }}
                                      >
                                        <Stack spacing={0.5}>
                                          <Typography
                                            variant="body2"
                                            fontWeight="500"
                                          >
                                            Modified by:{" "}
                                            {currentQuestion.modified_by}
                                          </Typography>
                                          <Typography
                                            variant="caption"
                                            color="text.secondary"
                                          >
                                            {new Date(
                                              currentQuestion.modified_at
                                            ).toLocaleString()}
                                          </Typography>
                                        </Stack>
                                      </Box>
                                    </Stack>
                                  ) : (
                                    <Stepper
                                      // sx={{
                                      //   gap: "10px",
                                      //   width: "100%",
                                      //   "& .MuiStepConnector-root": {
                                      //     display: "none !important",
                                      //     marginBottom: "24px",
                                      //   },
                                      //   "& .MuiStepContent-root": {
                                      //     // borderColor: "transparent !important",
                                      //   },
                                      //   "& .MiStepConnector-root": {
                                      //     "& .Mui-completed .MuiStepConnector-line":
                                      //       {
                                      //         border:
                                      //           "1px dashed #000000 !important",
                                      //       },
                                      //     "& .MuiStepConnector-line": {
                                      //       // borderColor: "transparent",
                                      //       minHeight: "8px",
                                      //       maxHeight: "8px",
                                      //     },
                                      //   },
                                      // }}
                                      activeStep={activeStep}
                                      orientation="vertical"
                                    >
                                      {steps.map((step, index) => (
                                        <Step
                                          key={step.label}
                                          // sx={{
                                          //   border: "1px solid #e5e7eb",
                                          //   borderLeft:
                                          //     index === activeStep
                                          //       ? "3px solid #519C66"
                                          //       : "1px solid #e5e7eb",
                                          //   // background: "#ffffff",
                                          //   padding: "8px",
                                          //   width: "100%",
                                          //   minWidth: "100%",
                                          //   boxSizing: "border-box",
                                          //   borderRadius: "6px",
                                          //   "& .MuiStepLabel-root": {
                                          //     "& .MuiStepLabel-iconContainer": {
                                          //       color: "#519C66",
                                          //       "& .MuiStepIcon-root.Mui-completed":
                                          //         {
                                          //           color: "#519C66",
                                          //         },
                                          sx={{
                                            "& .MuiStepIcon-root.Mui-active": {
                                              color: "transparent",
                                              borderRadius: "50%",
                                              border: "2px solid #519C66",
                                              "& .MuiStepIcon-text": {
                                                fill: "#519C66",
                                              },
                                            },
                                          }}
                                          // },
                                          //   },
                                          //   "& .MuiStepIcon-root.Mui-completed": {
                                          //     color: "#519C66",
                                          //   },
                                          //   // display:
                                          //   //   index === activeStep
                                          //   //     ? "flex"
                                          //   //     : "none !important",
                                          //   flexDirection: "column",
                                          // }}
                                        >
                                          <StepLabel
                                            optional={
                                              <Typography variant="caption">
                                                {step.description}
                                              </Typography>
                                            }
                                            error={
                                              activeStep > index &&
                                              !step.completed
                                            }
                                          >
                                            {step.label}
                                          </StepLabel>
                                          <StepContent>
                                            <Box sx={{ mb: 2 }}>
                                              {step.content(que)}
                                            </Box>
                                          </StepContent>
                                        </Step>
                                      ))}
                                    </Stepper>
                                  )}
                                  <CommentsSection que={que} />
                                </Box>
                              </Collapse>
                            </Box>
                          );
                        })
                    : ""}
                </Stack>
              </Stack>
              <Box
                sx={
                  changeSubTopic || reviewLaterConfirm || moveToPending
                    ? {
                        height: "100dvh",
                        width: "calc(40% - 10px)",
                        maxWidth: "400px",
                        ml: "10px",
                        zIndex: 9999,
                        position: "fixed",
                        top: "0",
                        right: 0,
                      }
                    : {
                        width: "calc(40% - 10px)",
                        maxWidth: "400px",
                        ml: "10px",
                      }
                }
              >
                {currentQuestion && (
                  <UpdatedQuestionPreviewWrapper
                    questionEditData={{
                      ...currentQuestion,
                      languages_available:
                        currentQuestion.translation
                          .map((s: { language: any }) => s.language)
                          .join(",") ?? "english",
                    }}
                  />
                )}
              </Box>
            </Stack>
          </motion.div>
        )}

        {questions.length === 0 ? (
          ""
        ) : (
          <Pagination
            sx={{
              width: "100%",
              borderTop: "1px solid #e5e7eb",
              bgcolor: "#f9fbfd",
              py: 1,
              gap: "8px",
            }}
            count={questions.length}
            variant="outlined"
            shape="rounded"
            page={
              currentQuestion
                ? questions.findIndex((q) => q.id === currentQuestion.id) + 1
                : 1
            }
            onChange={(event: any, newPage: number) =>
              handleChangePage(newPage - 1, undefined, questions)
            }
            renderItem={(item) => {
              const questionIndex = item.page ? item.page - 1 : 0;
              const question = questions[questionIndex];
              const questionId = question?.id ?? item.page;

              // ✅ decide bg color based on status
              let baseBg = "white";
              let baseColor = "#374151";
              if (question?.v2_to_v3 === "save_for_later") {
                // baseBg = "#fef9c3"; // light yellow
                // baseColor = "#a16207";
              } else if (
                question?.v2_to_v3 === "reviewed" ||
                question?.status === "reviewed"
              ) {
                baseBg = "#dcfce7"; // light green
                baseColor = "#15803d";
              }

              return (
                <PaginationItem
                  {...item}
                  page={
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                        px: 1,
                      }}
                    >
                      <span>#{questionId}</span>
                      {question?.v2_to_v3 === "save_for_later" && (
                        <BookmarkBorderRoundedIcon
                          sx={{ fontSize: 14, color: "#2563eb" }}
                        />
                      )}
                    </Box>
                  }
                  sx={{
                    transition: "all 0.3s ease",
                    borderRadius: "8px",
                    margin: "0 4px",
                    fontWeight: item.selected ? "bold" : "normal",
                    transform: item.selected ? "scale(1.1)" : "scale(1)",
                    boxShadow: item.selected
                      ? "0 4px 12px rgba(0,0,0,0.2)"
                      : "none",
                    bgcolor: item.selected
                      ? "white !important"
                      : "rgba(0, 0, 0, 0.08)", // selected overrides status
                    color: item.selected ? "black !important" : baseColor,
                    "&:hover": {
                      transform: "scale(1.05)",
                      bgcolor:
                        question?.v2_to_v3 === "reviewed"
                          ? "#86efac" // darker green hover
                          : item.selected
                          ? "#1d4ed8"
                          : "#f3f4f6",
                    },
                  }}
                />
              );
            }}
          />
        )}
      </Box>
    </AnimatePresence>
  ) : (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {"No cluster sselected."}
    </Box>
  );
}

export default SingleClusterCard;
